import './Skeleton.scss';
import { motion } from "framer-motion";

interface SkeletonProps {
    width?: string;
    height?: string;
    borderRadius?: string;
}

const Skeleton = ({ width = '100%', height = '100%', borderRadius = '4px' }: SkeletonProps) => {
    return (
        <div className="skeleton" >
            <motion.div
                style={{
                    width: width,
                    height: height,
                    borderRadius: borderRadius,
                    background: "#28282C",
                }}
                animate={{
                    opacity: [0.5, 1, 0.5],
                }}
                transition={{
                    duration: 1.5,
                    repeat: Infinity,
                    ease: "easeInOut",
                }}
            />
        </div>)
}

export default Skeleton